import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=6ee37c8f&scoped=true&"
import script from "./SettingsLayout.vue?vue&type=script&lang=js&"
export * from "./SettingsLayout.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLayout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SettingsLayout.vue?vue&type=style&index=1&id=6ee37c8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee37c8f",
  null
  
)

component.options.__file = "SettingsLayout.vue"
export default component.exports